// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".slider[data-v-3f020106]{margin-top:20px}@media(max-width:480px){.slider[data-v-3f020106]{margin-left:-23px;margin-right:-23px}}", ""]);
// Exports
module.exports = exports;
